import { render, staticRenderFns } from "./indexSetting.vue?vue&type=template&id=0ef2692e&scoped=true"
import script from "./indexSetting.vue?vue&type=script&lang=js"
export * from "./indexSetting.vue?vue&type=script&lang=js"
import style0 from "./indexSetting.vue?vue&type=style&index=0&id=0ef2692e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef2692e",
  null
  
)

export default component.exports